"use client";

import { c as _c } from "react/compiler-runtime";
import { faPaperPlane } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useMemo } from "react";
import { useAuth } from "@/components/auth/Auth";
import useCreateModalState from "@/hooks/useCreateModalState";
const BrainLeftSidebarCreateADirectMessageButton: React.FC = () => {
  const $ = _c(6);
  const {
    connectedProfile,
    activeProfileProxy
  } = useAuth();
  const {
    openDirectMessage
  } = useCreateModalState();
  connectedProfile?.handle;
  const isConnectedIdentity = !!connectedProfile?.handle && !activeProfileProxy;
  let t0;
  bb0: {
    if (isConnectedIdentity) {
      t0 = "Create DM";
      break bb0;
    }
    t0 = "Direct Message";
  }
  const label = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <FontAwesomeIcon icon={faPaperPlane} className="-tw-ml-1.5 tw-size-3 tw-flex-shrink-0" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== label) {
    t2 = <span>{label}</span>;
    $[1] = label;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== openDirectMessage || $[4] !== t2) {
    t3 = <button type="button" onClick={openDirectMessage} className="tw-flex tw-w-full tw-items-center tw-justify-center tw-gap-x-2 tw-rounded-lg tw-border-0 tw-bg-iron-800 tw-px-4 tw-py-2 tw-text-xs tw-font-semibold tw-text-iron-300 tw-ring-1 tw-ring-inset tw-ring-iron-700 tw-transition-all tw-duration-300 desktop-hover:hover:tw-text-primary-400 desktop-hover:hover:tw-ring-iron-700">{t1}{t2}</button>;
    $[3] = openDirectMessage;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
};
export default BrainLeftSidebarCreateADirectMessageButton;